"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const stockpile_style_1 = __importDefault(require("../stockpile.style"));
const stockpile_action_1 = __importDefault(require("../stockpile.action"));
const grid_1 = __importDefault(require("components/templates/grid"));
const stockpile_types_1 = require("../stockpile.types");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const stockpile_mutation_component_1 = __importDefault(require("./stockpile.mutation.component"));
const modal_1 = require("components/molecules/modal");
const svg_1 = require("components/atoms/svg");
const react_router_dom_1 = require("react-router-dom");
const authorization_1 = require("utils/authorization");
const debounces_1 = require("utils/debounces");
const Stockpile = () => {
    const { dataGrid, dataStates, isLoading, isSuccess, isError, errorMessage } = (0, store_1.useAppSelector)(state => state.master.stockpile);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const debouncedGetDataGrid = (0, debounces_1.useDebouncedCallback)((newDataStates) => {
        dispatch(stockpile_action_1.default.getDataGrid(newDataStates));
    }, 1000, [dispatch]);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Master Data', 'Stockpile');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                dispatch(stockpile_action_1.default.getDataGrid(dataStates));
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, fullScreen]);
    const actionCellRender = (0, custom_cell_grid_1.actionCell)([
        {
            type: 'other',
            permission: isAuthorized.change,
            icon: (0, jsx_runtime_1.jsx)(svg_1.EditIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(stockpile_action_1.default.onClickMutation({
                mutationMode: 'edit', dataItem: Object.assign(Object.assign({}, d), { is_active: {
                        value: Boolean(d.is_active),
                        status: d.is_active ? 'Active' : 'Inactive'
                    } })
            }))
        },
        {
            type: 'other',
            permission: isAuthorized.change,
            icon: (0, jsx_runtime_1.jsx)(svg_1.DeleteIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: 'delete', dataItem: d })),
        }
    ]);
    const actionColumn = [{
            title: '',
            width: '70px',
            sortable: false,
            filterable: false,
            show: isAuthorized.change,
            cell: actionCellRender,
            locked: true
        }];
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(stockpile_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(stockpile_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        debouncedGetDataGrid(newDataStates);
    };
    const onSortChange = (e) => {
        dispatch(stockpile_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        debouncedGetDataGrid(newDataStates);
    };
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, isLoading: isLoading, title: 'Master Data Stockpile', isAddNew: isAuthorized.change, onAddNew: () => dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: 'add' })) }), isSuccess && ((0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { messageSuccess: 'Data saved Successfully', onClose: () => {
                    dispatch(stockpile_action_1.default.getDataGrid(dataStates));
                    dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } })), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { appTheme: appTheme, style: { 'zIndex': 10 }, errorMessage: errorMessage, show: isError, onClose: () => {
                    dispatch(stockpile_action_1.default.toggleError({ isError: false, errorCode: 0, errorMessage: '' }));
                    dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: false }));
                } }), (0, jsx_runtime_1.jsx)(stockpile_mutation_component_1.default, {}), (0, jsx_runtime_1.jsx)(grid_1.default, { style: stockpile_style_1.default.gridHeight, dataGrid: dataGrid, columns: actionColumn.concat(fullScreen ? stockpile_types_1.stockpileColumnFullWidthProps : stockpile_types_1.stockpileColumnProps), dataStates: dataStates, pageable: true, sortable: true, sort: dataStates.sort, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange, fullScreen: fullScreen })] }));
};
exports.default = Stockpile;
